import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'submitBtn']
  static values = { tooltipTitle: String }

  connect() {
    bootstrap.Modal.getOrCreateInstance(this.element).show()
    this.submitBtnTargets.forEach((btn) => { btn.disabled = true })
    this.#initTooltips()
  }

  disconnect() {
    this.#tooltipInstances().forEach((tooltip) => { tooltip.dispose() })
  }

  toggleSubmit() {
    const allChecked = this.checkboxTargets.every((cb) => cb.checked)

    this.submitBtnTargets.forEach((btn) => { btn.disabled = !allChecked })
    this.#tooltipInstances().forEach((tooltip) => {
      allChecked ? tooltip.disable() : tooltip.enable()
    })
  }

  #initTooltips() {
    this.checkboxTargets.forEach((cb) => {
      new bootstrap.Tooltip(cb, { title: this.tooltipTitleValue, trigger: 'hover' })
    })
  }

  #tooltipInstances() {
    return this.checkboxTargets.map((cb) => bootstrap.Tooltip.getInstance(cb)).filter(Boolean)
  }
}
